import React from "react";
import {
  Table,
  TableRow,
  TableCell,
  TableBody,
  Grid,
  Card,
  Typography,
} from "@material-ui/core";
import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { makeStyles, createStyles, withStyles } from "@material-ui/core/styles";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { Skeleton } from "@material-ui/lab";
import { CircularProgress } from "@material-ui/core";

const useStyle = makeStyles((theme) => ({
  tableCell: {
    color: theme.palette.ePrimary?.base + "!important",
    paddingTop: "1% !important",
    paddingBottom: "1% !important",
  },
  tableCellTitle: {
    color: theme.palette.eRich?.base + "!important",
    paddingTop: "1% !important",
    paddingBottom: "1% !important",
  },
  paddingCard: {
    padding: "2% 2%",
    [theme.breakpoints.down("sm")]: {
      padding: "2% 5%",
    },
  },
  paddingCardPaymentStatus: {
    padding: "0% 0% !important",
  },
  paymentStatusSuccess: {
    background: theme.palette.eSecondary?.base + "!important",
  },
  paymentStatusError: {
    background: theme.palette.eTertiary?.base + "!important",
  },

  amountSuccess: {
    background: theme.palette.ePrimary?.base + "!important",
  },
  amountError: {
    background: theme.palette.eTertiary?.base + "!important",
  },
  paymentContentContainer: {
    width: "100%",
  },
  whiteColor: {
    color: theme.palette.eWhite?.base + "!important",
  },
  paymentInformation: {
    paddingLeft: "1%",
  },
  amountTitleMobile: {
    color: theme.palette.eWhite?.base + "!important",
    paddingLeft: "4%",
    fontSize: "large !important",
  },
  amountValueMobile: {
    color: theme.palette.eWhite?.base + "!important",
    fontSize: "large !important",
  },
  mt5: {
    marginTop: "1%",
  },
  h3Primary: {
    fontSize: "medium !important",
    [theme.breakpoints.down("sm")]: {
      fontSize: "inherit !important",
    },
  },
  amountDateContainer: {
    padding: "1% 1% 1% 0% !important",
    width: "53% !important",
  },
  paymentContentContainer: {
    width: "100%",
  },
  mobileAmountContainer: {
    padding: "1% 1% 1% 4% !important",
    width: "63% !important",
  },
  mobileDate: {
    marginLeft: "2.6rem",
  },
}));
export default function PaymentConfirmationContent({
  response,
  accountId,
  location,
  paymentError,
  postData,
}) {
  localStorage.setItem("amount", postData?.amount);
  let labels = useSelector(
    (store) => store?.labels?.data?.getLabels?.E_PAYMENT_CONFIRMATION
  );
  const isTabletOrMobile = useMediaQuery({ query: "(min-width: 550px)" });
  const styleClass = useStyle();
  let headStyle = `tableBorder ${styleClass.h3Primary}`;

  const { t: label, ready: labelReady } = useTranslation(
    "label-NESCO_Customer_No_label"
  );
  let TransactionDate = localStorage.getItem("transactionDate");
  const customerId = localStorage.getItem("accountId");
  const { t: payLabel, ready: payLabelReady } = useTranslation(
    "label-E_NESCO_PAYMENT"
  );
  const REQUEST_CANCELLED_URL = "REQUEST_CANCELLED_URL";
  const RETRY_ALLOWED = "RETRY_ALLOWED";
  const RETRY_NOT_ALLOWED = "RETRY_NOT_ALLOWED";
  const failure = "failure";
  const INTERNAL_ERROR = "INTERNAL_ERROR";
  const SUCCESS = "SUCCESS";
  const RETRY_NOT_ALLOWED_FAILED_C2M_API = "RETRY_NOT_ALLOWED_FAILED_C2M_API";
  const DATE_MONTH_YEAR_FORMAT = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.E_DATE_MONTH_YEAR_FORMAT
  );
  const TIMESTAMP_DATE_FORMAT = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.TIMESTAMP_DATE_FORMAT
  );
  const BkashCurrency = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.E_CURRENCY_CODE
  );
  return (
    <div className={styleClass.paymentContentContainer}>
      <React.Fragment>
        {postData ? (
          <>
            {isTabletOrMobile ? (
              <Grid
                container
                direction="row"
                justify="flex-start"
                className={styleClass.paddingCard}
              >
                <Grid item xs={12}>
                  <Typography
                    className={styleClass.paymentInformation}
                    variant="body1"
                  >
                    <b>{labels?.E_PAYMENT_CONFIRMATION_INFORMATION_TITTLE}</b>
                  </Typography>
                  {postData?.status === SUCCESS ? (
                    <>
                      <Table size="small">
                        <TableBody>
                          <TableRow>
                            <TableCell
                              className={[headStyle, styleClass.tableCellTitle]}
                            >
                              {labelReady ? (
                                label("N_CUSTOMER_NO")
                              ) : (
                                <Skeleton />
                              )}
                            </TableCell>
                            <TableCell
                              className={[headStyle, styleClass.tableCell]}
                              align="left"
                            >
                              {postData?.payerReference}
                            </TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell
                              className={[headStyle, styleClass.tableCellTitle]}
                            >
                              {labels?.E_PAYMENT_CONFIRMATION_RECEIPT_NUMBER}
                            </TableCell>
                            <TableCell
                              className={[headStyle, styleClass.tableCell]}
                              align="left"
                            >
                              {/* {postData?.trxID} */}
                              {localStorage.getItem("preChargeTransactionId")}
                            </TableCell>
                          </TableRow>

                          {postData?.bKashTransactionId &&
                            postData.status ===
                              RETRY_NOT_ALLOWED_FAILED_C2M_API && (
                              <TableRow>
                                <TableCell
                                  className={[
                                    headStyle,
                                    styleClass.tableCellTitle,
                                  ]}
                                >
                                  {labels?.BKASH_TRANSACTION_ID}
                                </TableCell>
                                <TableCell
                                  className={[headStyle, styleClass.tableCell]}
                                  align="left"
                                >
                                  {/* {postData?.trxID} */}
                                  {postData?.bKashTransactionId}
                                </TableCell>
                              </TableRow>
                            )}

                          <TableRow className={styleClass.paymentStatusSuccess}>
                            <TableCell
                              className={[headStyle, styleClass.tableCellTitle]}
                            >
                              <span className={styleClass.whiteColor}>
                                {labels?.E_PAYMENT_CONFIRMATION_PAYMENT_STATUS}
                              </span>
                            </TableCell>
                            <TableCell className={headStyle} align="left">
                              <span className={styleClass.whiteColor}>
                                {labels?.E_PAYMENT_CONFIRMATION_SUCCESS_STATUS}
                              </span>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell
                              className={[headStyle, styleClass.tableCellTitle]}
                            >
                              {payLabelReady ? payLabel("E_PAYMENT_TYPE") : ""}
                            </TableCell>
                            <TableCell
                              className={[headStyle, styleClass.tableCell]}
                              align="left"
                            >
                              {payLabelReady
                                ? payLabel("E_PAYMENT_WALLET")
                                : ""}
                            </TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell
                              className={[headStyle, styleClass.tableCellTitle]}
                            >
                              {labels?.E_PAYMENT_CONFIRMATION_TRANSACTION_DATE}
                            </TableCell>
                            <TableCell
                              className={[headStyle, styleClass.tableCell]}
                              align="left"
                            >
                              {moment(
                                postData?.paymentExecuteTime,
                                TIMESTAMP_DATE_FORMAT
                              ).format(DATE_MONTH_YEAR_FORMAT)}
                            </TableCell>
                          </TableRow>
                          <TableRow className={styleClass.amountSuccess}>
                            <TableCell
                              className={[headStyle, styleClass.tableCellTitle]}
                            >
                              <b className={styleClass.whiteColor}>
                                {labels?.E_PAYMENT_CONFIRMATION_AMOUNT}
                              </b>
                            </TableCell>
                            <TableCell className={headStyle} align="left">
                              <span className={styleClass.whiteColor}>
                                {postData
                                  ? BkashCurrency + " " + postData?.amount
                                  : null}
                              </span>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </>
                  ) : (
                    <>
                      <Table size="small">
                        <TableBody>
                          <TableRow>
                            <TableCell
                              className={[headStyle, styleClass.tableCellTitle]}
                            >
                              {labelReady ? label("N_CUSTOMER_NO") : ""}
                            </TableCell>
                            <TableCell
                              className={[headStyle, styleClass.tableCell]}
                              align="left"
                            >
                              {customerId}
                            </TableCell>
                          </TableRow>
                          <TableRow className={styleClass.paymentStatusError}>
                            <TableCell
                              className={[headStyle, styleClass.tableCellTitle]}
                            >
                              <span className={styleClass.whiteColor}>
                                {labels?.E_PAYMENT_CONFIRMATION_PAYMENT_STATUS}
                              </span>
                            </TableCell>
                            {postData?.statusMessage ===
                              REQUEST_CANCELLED_URL &&
                            postData?.status === RETRY_ALLOWED ? (
                              <>
                                <TableCell className={headStyle} align="left">
                                  <span className={styleClass.whiteColor}>
                                    {payLabelReady ? (
                                      payLabel("E_PAYMENT_CANCEL_CASE")
                                    ) : (
                                      <Skeleton />
                                    )}
                                  </span>
                                </TableCell>
                              </>
                            ) : null}
                            {postData?.status === RETRY_NOT_ALLOWED ||
                            postData?.statusMessage === failure ||
                            postData?.status === INTERNAL_ERROR ||
                            postData?.status ===
                              RETRY_NOT_ALLOWED_FAILED_C2M_API ? (
                              <>
                                <TableCell className={headStyle} align="left">
                                  <span className={styleClass.whiteColor}>
                                    {payLabelReady ? (
                                      payLabel("E_PAYMENT_FAILED_CASE")
                                    ) : (
                                      <Skeleton />
                                    )}
                                  </span>
                                </TableCell>
                              </>
                            ) : null}
                            {postData?.status === RETRY_ALLOWED &&
                            postData?.statusMessage !==
                              REQUEST_CANCELLED_URL ? (
                              <>
                                <TableCell className={headStyle} align="left">
                                  <span className={styleClass.whiteColor}>
                                    {payLabelReady ? (
                                      payLabel("E_PAYMENT_FAILED_CASE")
                                    ) : (
                                      <Skeleton />
                                    )}
                                  </span>
                                </TableCell>
                              </>
                            ) : null}
                          </TableRow>
                          {postData?.bKashTransactionId &&
                            postData.status ===
                              RETRY_NOT_ALLOWED_FAILED_C2M_API && (
                              <TableRow>
                                <TableCell
                                  className={[
                                    headStyle,
                                    styleClass.tableCellTitle,
                                  ]}
                                >
                                  {labels?.BKASH_TRANSACTION_ID}
                                </TableCell>
                                <TableCell
                                  className={[headStyle, styleClass.tableCell]}
                                  align="left"
                                >
                                  {/* {postData?.trxID} */}
                                  {postData?.bKashTransactionId}
                                </TableCell>
                              </TableRow>
                            )}
                          <TableRow>
                            <TableCell
                              className={[headStyle, styleClass.tableCellTitle]}
                            >
                              {payLabelReady ? (
                                payLabel("E_PAYMENT_TYPE")
                              ) : (
                                <Skeleton />
                              )}
                            </TableCell>
                            <TableCell
                              className={[headStyle, styleClass.tableCell]}
                              align="left"
                            >
                              {payLabelReady ? (
                                payLabel("E_PAYMENT_WALLET")
                              ) : (
                                <Skeleton />
                              )}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell
                              className={[headStyle, styleClass.tableCellTitle]}
                            >
                              {labels?.E_PAYMENT_CONFIRMATION_TRANSACTION_DATE}
                            </TableCell>
                            <TableCell
                              className={[headStyle, styleClass.tableCell]}
                              align="left"
                            >
                              {moment(
                                TransactionDate,
                                TIMESTAMP_DATE_FORMAT
                              ).format(DATE_MONTH_YEAR_FORMAT)}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </>
                  )}
                </Grid>
              </Grid>
            ) : (
              <>
                {postData.status === SUCCESS ? (
                  <>
                    <Grid
                      container
                      direction="row"
                      className={styleClass.paddingCard}
                    >
                      <Grid item xs={12}>
                        <Typography
                          className={styleClass.paymentInformation}
                          variant="body1"
                        >
                          <b>
                            {labels?.E_PAYMENT_CONFIRMATION_INFORMATION_TITTLE}
                          </b>
                        </Typography>
                        <Table size="small">
                          <TableBody>
                            <TableRow>
                              <TableCell
                                className={[
                                  headStyle,
                                  styleClass.tableCellTitle,
                                ]}
                              >
                                {labelReady ? (
                                  label("N_CUSTOMER_NO")
                                ) : (
                                  <Skeleton />
                                )}
                              </TableCell>
                              <TableCell
                                className={[headStyle, styleClass.tableCell]}
                                align="left"
                              >
                                {postData?.payerReference}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell
                                className={[
                                  headStyle,
                                  styleClass.tableCellTitle,
                                ]}
                              >
                                {labels?.E_PAYMENT_CONFIRMATION_RECEIPT_NUMBER}
                              </TableCell>
                              <TableCell
                                className={[headStyle, styleClass.tableCell]}
                                align="left"
                              >
                                {/* {postData?.trxID} */}
                                {localStorage.getItem("preChargeTransactionId")}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </Grid>
                    </Grid>

                    <Grid container className={styleClass.mt5}>
                      <Grid item xs={12}>
                        <Table size="small">
                          <TableBody>
                            <TableRow
                              className={styleClass.paymentStatusSuccess}
                            >
                              <TableCell
                                colSpan={2}
                                align="center"
                                className={[
                                  headStyle,
                                  styleClass.tableCellTitle,
                                ]}
                              >
                                <span className={styleClass.whiteColor}>
                                  {
                                    labels?.E_PAYMENT_CONFIRMATION_PAYMENT_STATUS
                                  }
                                </span>
                              </TableCell>
                            </TableRow>
                            <TableRow
                              className={styleClass.paymentStatusSuccess}
                            >
                              <TableCell
                                align="center"
                                colSpan={2}
                                className={headStyle}
                              >
                                <span className={styleClass.whiteColor}>
                                  {
                                    labels?.E_PAYMENT_CONFIRMATION_SUCCESS_STATUS
                                  }
                                </span>
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </Grid>
                    </Grid>

                    <Grid container className={styleClass.paddingCard}>
                      <Grid item xs={12}>
                        <Table size="small">
                          <TableBody>
                            <TableRow>
                              <TableCell
                                className={[
                                  headStyle,
                                  styleClass.tableCellTitle,
                                ]}
                              >
                                {
                                  labels?.E_PAYMENT_CONFIRMATION_TRANSACTION_DATE
                                }
                              </TableCell>
                              <TableCell
                                className={[headStyle, styleClass.tableCell]}
                                align="left"
                              >
                                <span className={styleClass.mobileDate}>
                                  {" "}
                                  {moment(
                                    postData?.paymentExecuteTime,
                                    TIMESTAMP_DATE_FORMAT
                                  ).format(DATE_MONTH_YEAR_FORMAT)}
                                </span>
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </Grid>
                    </Grid>

                    <Grid container className={styleClass.mt5}>
                      <Grid item xs={12}>
                        <Table size="small">
                          <TableBody>
                            <TableRow className={styleClass.amountSuccess}>
                              <TableCell
                                className={[
                                  headStyle,
                                  styleClass.tableCellTitle,
                                  styleClass.mobileAmountContainer,
                                ]}
                              >
                                <b className={styleClass.amountTitleMobile}>
                                  {labels?.E_PAYMENT_CONFIRMATION_AMOUNT}
                                </b>
                              </TableCell>
                              <TableCell className={headStyle} align="left">
                                <span
                                  className={[
                                    styleClass.tableCell,
                                    styleClass.amountValueMobile,
                                  ]}
                                >
                                  {postData
                                    ? BkashCurrency + " " + postData?.amount
                                    : null}
                                </span>
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </Grid>
                    </Grid>
                  </>
                ) : (
                  <>
                    <Grid
                      container
                      direction="row"
                      className={styleClass.paddingCard}
                    >
                      <Grid item xs={12}>
                        <Typography
                          className={styleClass.paymentInformation}
                          variant="body1"
                        >
                          <b>
                            {labels?.E_PAYMENT_CONFIRMATION_INFORMATION_TITTLE}
                          </b>
                        </Typography>
                        <Table size="small">
                          <TableBody>
                            <TableRow>
                              <TableCell
                                className={[
                                  headStyle,
                                  styleClass.tableCellTitle,
                                ]}
                              >
                                {labelReady ? (
                                  label("N_CUSTOMER_NO")
                                ) : (
                                  <Skeleton />
                                )}
                              </TableCell>
                              <TableCell
                                className={[headStyle, styleClass.tableCell]}
                                align="left"
                              >
                                {customerId}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </Grid>
                    </Grid>

                    <Grid container className={styleClass.mt5}>
                      <Grid item xs={12}>
                        <Table size="small">
                          <TableBody>
                            <TableRow className={styleClass.paymentStatusError}>
                              <TableCell
                                colSpan={2}
                                align="center"
                                className={[
                                  headStyle,
                                  styleClass.tableCellTitle,
                                ]}
                              >
                                <span className={styleClass.whiteColor}>
                                  {
                                    labels?.E_PAYMENT_CONFIRMATION_PAYMENT_STATUS
                                  }
                                </span>
                              </TableCell>
                            </TableRow>
                            <TableRow className={styleClass.paymentStatusError}>
                              {postData?.statusMessage ===
                                REQUEST_CANCELLED_URL &&
                              postData?.status === RETRY_ALLOWED ? (
                                <>
                                  <TableCell
                                    className={headStyle}
                                    align="center"
                                  >
                                    <span className={styleClass.whiteColor}>
                                      {payLabelReady ? (
                                        payLabel("E_PAYMENT_CANCEL_CASE")
                                      ) : (
                                        <Skeleton />
                                      )}
                                    </span>
                                  </TableCell>
                                </>
                              ) : null}
                              {postData?.status === RETRY_NOT_ALLOWED ||
                              postData?.statusMessage === failure ||
                              postData?.status === INTERNAL_ERROR ? (
                                <>
                                  <TableCell
                                    className={headStyle}
                                    align="center"
                                  >
                                    <span className={styleClass.whiteColor}>
                                      {payLabelReady ? (
                                        payLabel("E_PAYMENT_FAILED_CASE")
                                      ) : (
                                        <Skeleton />
                                      )}
                                    </span>
                                  </TableCell>
                                </>
                              ) : null}
                              {postData?.status === RETRY_ALLOWED &&
                              postData?.statusMessage !==
                                REQUEST_CANCELLED_URL ? (
                                <>
                                  <TableCell
                                    className={headStyle}
                                    align="center"
                                  >
                                    <span className={styleClass.whiteColor}>
                                      {payLabelReady ? (
                                        payLabel("E_PAYMENT_FAILED_CASE")
                                      ) : (
                                        <Skeleton />
                                      )}
                                    </span>
                                  </TableCell>
                                </>
                              ) : null}
                            </TableRow>
                          </TableBody>
                        </Table>
                      </Grid>
                    </Grid>

                    <Grid container className={styleClass.paddingCard}>
                      <Grid item xs={12}>
                        <Table size="small">
                          <TableBody>
                            <TableRow>
                              <TableCell
                                className={[
                                  headStyle,
                                  styleClass.tableCellTitle,
                                ]}
                              >
                                {payLabelReady ? (
                                  payLabel("E_PAYMENT_TYPE")
                                ) : (
                                  <Skeleton />
                                )}
                              </TableCell>
                              <TableCell
                                className={[headStyle, styleClass.tableCell]}
                                align="left"
                              >
                                {payLabelReady ? (
                                  payLabel("E_PAYMENT_WALLET")
                                ) : (
                                  <Skeleton />
                                )}
                              </TableCell>
                            </TableRow>
                            {postData?.bKashTransactionId &&
                              postData.status ===
                                RETRY_NOT_ALLOWED_FAILED_C2M_API && (
                                <TableRow>
                                  <TableCell
                                    className={[
                                      headStyle,
                                      styleClass.tableCellTitle,
                                    ]}
                                  >
                                    {labels?.BKASH_TRANSACTION_ID}
                                  </TableCell>
                                  <TableCell
                                    className={[
                                      headStyle,
                                      styleClass.tableCell,
                                    ]}
                                    align="left"
                                  >
                                    {/* {postData?.trxID} */}
                                    {postData?.bKashTransactionId}
                                  </TableCell>
                                </TableRow>
                              )}
                            <TableRow>
                              <TableCell
                                className={[
                                  headStyle,
                                  styleClass.tableCellTitle,
                                ]}
                              >
                                {
                                  labels?.E_PAYMENT_CONFIRMATION_TRANSACTION_DATE
                                }
                              </TableCell>
                              <TableCell
                                className={[headStyle, styleClass.tableCell]}
                                align="left"
                              >
                                {moment(
                                  TransactionDate,
                                  TIMESTAMP_DATE_FORMAT
                                ).format(DATE_MONTH_YEAR_FORMAT)}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </Grid>
                    </Grid>
                  </>
                )}
              </>
            )}
          </>
        ) : (
          <>
            <Grid container justify="center" alignItems="center">
              <Grid item justify="center" alignItems="center">
                <CircularProgress></CircularProgress>
              </Grid>
            </Grid>
            <Grid container justify="center" alignItems="center">
              <Grid item justify="center" alignItems="center">
                <Typography variant="body1">
                  {payLabelReady ? payLabel("E_PAYMENT_WAIT") : <Skeleton />}
                </Typography>
              </Grid>
            </Grid>
          </>
        )}
      </React.Fragment>
    </div>
  );
}
